import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Tick from "../../assets/wellnesstick.png";

const SignatureTherapies = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const therapies = [
    {
      title: "Cognitive Behavioural Therapy (CBT)",
      desc: "CBT is one of the most effective tools in modern psychology, especially for anxiety, overthinking, depression, and low self-worth. In this therapy, you learn to identify unhelpful thought patterns that drive your emotions and behaviours. With professional guidance, we work together to reframe those thoughts, build healthier beliefs, and take practical steps toward a calmer, more confident you."
    },
    {
      title: "Inner Child Healing",
      desc: "So many of our adult struggles trace back to wounds we received as children—moments where we felt unseen, unloved, or unsafe. This therapy reconnects you with those younger parts of yourself through guided dialogue, visualization, and deep emotional work, helping you heal from abandonment, trust issues, and childhood trauma."
    },
    {
      title: "Schema Therapy",
      desc: "This approach identifies and transforms lifelong emotional patterns and beliefs like “I’m not worthy” or “People always leave me.” It’s deeply effective for those facing recurring relationship problems or identity struggles rooted in childhood experiences."
    },
    {
      title: "Mindfulness-Based Therapy",
      desc: "Using breathwork, awareness exercises, and meditative techniques, this therapy helps reduce stress and anxiety by anchoring you in the present moment. It’s especially beneficial for those experiencing burnout or emotional overwhelm."
    },
    {
      title: "Grief & Loss Therapy",
      desc: "Loss—whether of a person, relationship, or dream—can be life-altering. This therapy offers a space for mourning and meaning-making, allowing you to process grief at your pace while finding hope again."
    },
    {
      title: "Trauma-Informed Therapy",
      desc: "This gentle, safety-first approach supports healing from emotional, physical, or sexual trauma. Therapy is paced according to your comfort, never rushed, and always centered on your emotional safety and trust."
    },
    {
      title: "Access Consciousness® Clearing",
      desc: "An energetic technique that clears emotional blocks and subconscious limitations. Ideal for those struggling with emotional stagnancy, relationship patterns, or deep-seated self-doubt."
    },
    {
      title: "Narrative Therapy",
      desc: "You are not your past. Narrative thYou are not your past. Narrative therapy helps you rewrite your inner story—replacing scripts of pain and powerlessness with stories of strength, choice, and transformation.erapy helps you rewrite your inner story—replacing old scripts with empowering truths."
    },
    {
      title: "Compassion-Focused Therapy",
      desc: "If you have an overactive inner critic, this therapy helps you develop kindness and self- acceptance. It’s deeply healing for those struggling with guilt, shame, or harsh self- judgment."
    },
  ];

  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div>
      {/* Signature Therapies Section */}
      <section data-aos="fade-up" className="px-6 md:px-12 py-12 bg-white text-white">
        <h2 className="text-2xl md:text-4xl text-center text-black font-bold mb-6 md:mb-8">
          Our Signature Therapies
        </h2>
        <p className="max-w-3xl text-center text-black text-base md:text-lg mx-auto mb-12">
          At Butterfly Wellness, we combine clinical expertise with compassionate listening 
          and intuitive healing. Each therapy is offered as a path to self-understanding, 
          emotional release, and deep inner transformation. Here’s a closer look at the life-changing therapies we offer:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {therapies.map((therapy, index) => (
            <div
              key={index}
              className="bg-gradient-to-r from-[#48A39B] to-[#00948B] p-4 md:p-6 rounded-xl shadow-lg hover:opacity-90 transition-all flex flex-col justify-between"
            >
              <h3 className="text-lg md:text-xl font-bold mb-3">{therapy.title}</h3>

              <p
                className={`text-sm mb-4 md:mb-6 ${
                  expandedIndex === index ? "" : "line-clamp-3"
                }`}
              >
                {therapy.desc}
              </p>

              <button
                onClick={() => toggleExpand(index)}
                className="text-white text-sm md:text-base hover:underline mt-auto self-start"
              >
                {expandedIndex === index ? "Show less" : "Read more"}
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Butterfly Section */}
      <section data-aos="fade-up" className="bg-gray-50 px-6 md:px-12 py-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-start">
          {/* Left Column - Heading & Button */}
          <div className="text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 uppercase">
              Why Choose <br className="hidden md:inline" />
              Butterfly <br className="hidden md:inline" />
              Wellness?
            </h2>
            <a
              href="https://wa.me/919952753900"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-[#005CA8] text-white font-semibold rounded hover:opacity-90 transition inline-block text-center"
            >
              Take the First Step
            </a>
          </div>

          {/* Right Column - Bullet Points */}
          <div className="space-y-4 text-gray-700">
            {[
              "Led by an experienced psychologist and transformation coach",
              "A warm, private, and judgment-free healing environment",
              "Personalized therapy plans created just for your needs",
              "A unique blend of scientific and soulful healing techniques",
              "Convenient online sessions for your comfort and privacy"
            ].map((point, idx) => (
              <div key={idx} className="flex items-start">
                <img src={Tick} alt="tick" className="w-5 h-5 mr-3 mt-1" />
                <p className="font-medium text-sm md:text-base">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SignatureTherapies;
